<template>
  <div id="Zbcp">
    <!-- <el-tabs v-model="activeName">
      <el-tab-pane label="漆面膜" name="first"></el-tab-pane>
      <el-tab-pane label="窗膜" name="second"></el-tab-pane>
    </el-tabs> -->
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="标题：">
          <el-input v-model.trim="queryForm.title" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="content">
        <el-table
          :data="tableData"
          style="width: 100%"
          height="550"
          row-key="Id"
          id="table"
          ref="table"
        >
          <el-table-column prop="id" label="编号" key="id"> </el-table-column>
          <el-table-column prop="title" label="标题" key="title">
          </el-table-column>
          <el-table-column prop="type" key="type" label="资源类型">
            <template slot-scope="scope">
              {{
                scope.row.type == 1
                  ? "公众号链接"
                  : scope.row.type == 2
                  ? "自定义内容"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="图片">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.image"
                alt
                fit="cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="content"
            label="内容"
            key="content"
          ></el-table-column>

          <el-table-column
            label="创建时间"
            prop="createdAt"
            key="createdAt"
          ></el-table-column>
          <el-table-column width="100" prop="todo" label="操作" key="todo">
            <template slot-scope="scope">
              <span @click="bj(scope.$index, scope.row)" class="btns"
                >编辑</span
              >
              <span @click="sc(scope.$index, scope.row)" class="btns"
                >删除</span
              >
              <span class="handle el-icon-rank"></span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :current-page="currentPage"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改新闻"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="标题：" prop="title">
          <el-input v-model.trim="editForm.title" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="资源类型：" prop="type">
          <el-select v-model="editForm.type" placeholder="--选择资源类型--">
            <el-option
              v-for="(item, index) in sourceTypeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="公众号链接："
          prop="content"
          v-if="editForm.type == 1"
        >
          <el-input v-model.trim="editForm.content" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="自定义内容：" prop="content" v-if="editForm.type == 2">
          <vue-editor
            id="editeditor"
            useCustomImageHandler
            @image-added="handleImageAdded"
            v-model="editForm.content"
          >
          </vue-editor>
        </el-form-item>

        <el-form-item label="图片：" required>
          <el-upload
            :class="imagesWF.length > 0 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="false"
            :limit="1"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加新闻"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="100px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item label="标题：" prop="title">
          <el-input v-model.trim="newForm.title" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="资源类型：" prop="type">
          <el-select v-model="newForm.type" placeholder="--选择资源类型--">
            <el-option
              v-for="(item, index) in sourceTypeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="公众号链接："
          prop="content"
          v-if="newForm.type == 1"
        >
          <el-input v-model.trim="newForm.content" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="自定义内容：" prop="content" v-if="newForm.type == 2">
          <vue-editor
            id="addeditor"
            useCustomImageHandler
            @image-added="handleImageAdded"
            v-model="newForm.content"
          >
          </vue-editor>
        </el-form-item>

        <el-form-item label="图片：" required>
          <el-upload
            :class="imagesWF.length > 0 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="false"
            :limit="1"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getXW, getOur } from "./../axios/api";
import { VueEditor } from "vue2-editor";
import moment from "dayjs";
export default {
  name: "Xw",
  components: {
    VueEditor,
  },
  data() {
    return {
      sourceTypeList: [
        { id: 1, name: "公众号链接" },
        { id: 2, name: "自定义内容" },
      ], // 资源类型
      imagesWF: [],
      isQmFilm: null,
      queryForm: {}, // 根据条件查询表单
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      newData: false,
      newForm: {},
      editFormVisible: false,
      editForm: {
        title: "",
        content: "",
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        type: [{ required: true, message: "请输入类型", trigger: "change" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 上传图片时的钩子
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      // console.log(file);
      var that = this;
      const formData = new FormData();
      if (file) {
        formData.append("file", file);
      }
      // console.log(formData.get("file"));
      // return;
      getOur
        .upload(formData)
        .then(function (res) {
          // console.log(res);
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            // console.log(res.data);
            //cursorLocation是光标位置，res.data.url是上传后的url地址
            Editor.insertEmbed(cursorLocation, "image", res.data.url);
            resetUploader(); //重置文件上传器
            that.$message.success("图片上传成功!");
            return res.data.url;
          }
        })
        .catch(function (res) {});
    },

    // 窗膜上传图片时的钩子
    handleWFOnchange(file, fileList) {
      var that = this;
      const formData = new FormData();
      if (file) {
        formData.append("file", file.raw);
      }
      // console.log(formData.get('file'))

      getXW
        .upload(formData)
        .then(function (res) {
          console.log(res);
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            // console.log(res.data)

            that.imagesWF.push(res.data);

            that.$message.success("上传成功!");
          }
        })
        .catch(function (res) {});
    },
    // 窗膜上传图片的删除
    handleWFRemove(file, fileList) {
      if (fileList) {
        this.imagesWF = fileList;
      }
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.init();
    },
    // 搜索
    search: function () {
      var that = this;
      that.currentPage = 1;
      that.init();
    },
    // 重置
    reset: function () {
      var that = this;
      that.queryForm = {};
      that.currentPage = 1;
      that.init();
    },
    // 添加
    add: function () {
      this.newData = true;
    },

    newClose(done) {
      this.newData = false;
      this.$refs["newForm"].clearValidate();
      this.imagesWF = [];
    },
    newCancel: function () {
      this.newData = false;
      this.$refs["newForm"].clearValidate();
      this.imagesWF = [];
    },
    newUpdate: function () {
      var that = this;
      that.$refs["newForm"].validate((valid) => {
        if (valid) {
          let newImages = [];
          that.imagesWF.map((img) => {
            newImages.push(img.url);
          });

          if (newImages.length <= 0) {
            that.$message.warning("请上传图片!");
          } else {
            var data = {
              title: that.newForm.title, // 标题
              type: that.newForm.type,
              content: that.newForm.content, // 内容
              image: newImages.toString(),
            };
            // console.log("添加新闻数据：", data);
            // return;
            getXW
              .addTable(JSON.stringify(data))
              .then(function (res) {
                console.log(res);
                if (res.code !== 0) {
                  that.$alert(res.message + "!", "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  that.$message.success("添加成功!");
                  that.newData = false;
                  that.newForm = {};
                  that.$refs["newForm"].clearValidate();
                  that.imagesWF = [];
                  that.init();
                }
              })
              .catch(function (res) {});
          }
        }
      });
    },

    // 编辑
    bj: function (index, row) {
      console.log(row);
      var that = this;
      that.editForm = row;

      that.imagesWF = [{ url: row.image }];

      this.editFormVisible = true; //显示弹框
    },
    handleClose(done) {
      this.$refs["editForm"].clearValidate();
      this.editFormVisible = false;
      this.imagesWF = [];
    },
    handleCancel: function () {
      this.$refs["editForm"].clearValidate();
      this.editFormVisible = false;
      this.imagesWF = [];
    },
    handleUpdate: function () {
      var that = this;
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          let imagesWFUrl = [];
          that.imagesWF.map((img) => {
            imagesWFUrl.push(img.url);
          });

          if (imagesWFUrl.length <= 0) {
            that.$message.warning("请上传图片!");
          } else {
            let data = {
              title: that.editForm.title,
              type: that.editForm.type,
              content: that.editForm.content,
              image: imagesWFUrl.toString(),
            };

            getXW
              .editTable(data, that.editForm.id)
              .then(function (res) {
                console.log(res);
                if (res.code !== 0) {
                  that.$alert(res.message + "!", "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  that.$message.success("更新成功!");
                  that.editFormVisible = false;
                  that.$refs["editForm"].clearValidate();
                  that.imagesWF = [];
                  that.init();
                }
              })
              .catch(function (res) {});
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除
    sc: function (index, row) {
      var that = this;
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getXW
            .delTable({
              id: row.id,
            })
            .then(function (res) {
              // console.log(res);
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("删除成功!");
                that.init();
              }

              // that.init();
            })
            .catch(function (res) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    init: function () {
      var that = this;
      let data = {
        title: that.queryForm.title ? that.queryForm.title : undefined,
        pageSize: that.pagesize,
        pageNumber: that.currentPage,
      };
      // console.log(data)
      //获取窗膜table列表
      getXW.getTable(data).then(function (res) {
        // console.log(res);
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          const { list, totalNumber } = res.data;
          list.map((lis) => {
            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );
          });
          // console.log(list);
          that.total = totalNumber;
          that.tableData = list;
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-table,
.el-table__expanded-cell {
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/page/Xw.vue